import React, { ChangeEvent, useState } from 'react';

export default function ChatAuthorEntry(props: { onSetAuthor: (author: string) => void }) {
  const [chatAuthorInput, setChatAuthorInput] = useState<string>('');
  const [agreedToTerms, setAgreedToTerms] = useState<boolean>(false);
  return (
    <div style={{ fontSize: '10px' }}>
      <div>
        <span className="boxcast-chat--info">Create a username to participate</span>
        <span style={{ float: 'right' }}>{chatAuthorInput.length || 0}/25</span>
      </div>
      <form
        className="boxcast-chat--form boxcast-chat--author-form"
        onSubmit={(e) => {
          e.preventDefault();
          props.onSetAuthor(chatAuthorInput);
        }}
      >
        <input
          name="author"
          type="text"
          maxLength={25}
          value={chatAuthorInput}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setChatAuthorInput(e.target.value)}
          placeholder="Type name to enter chat..."
          className="boxcast-chat--input"
        />
        <label htmlFor="boxcast-chat--agree-terms" className="boxcast-chat--agree-terms">
          <input
            id="boxcast-chat--agree-terms"
            type="checkbox"
            checked={agreedToTerms}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setAgreedToTerms(e.target.checked)}
          />
          <span>
            I agree to the{' '}
            <a
              href="https://www.boxcast.com/legal/terms"
              target="_blank"
              className="boxcast-chat--terms"
            >
              terms and conditions
            </a>
            .
          </span>
        </label>
        <button
          type="submit"
          className="boxcast-button boxcast-chat--enter-chat-btn"
          disabled={!agreedToTerms}
        >
          Enter Chat
        </button>
      </form>
    </div>
  );
}
